import type { GetterTree } from 'vuex';

import { STEPS_NAMES } from '@/consts/steps.const';

import type { State } from '../interfaces/state';
import type { AppError, StepsState } from './interfaces';

export enum StepsGetters {
  GetCurrentStep = 'Steps:GET_CURRENT_STEP',
  GetStepData = 'Steps:GET_STEP_DATA',
  IsDataLoading = 'Steps:IS_DATA_LOADING',
  GetError = 'Steps:GET_ERROR',
  DisclaimerStatus = 'Steps:GET_DISCLAIMER_STATUS',
  GetOnfidoToken = 'Steps:GET_ONFIDO_TOKEN',
}

export interface StepsGetterData {
  [StepsGetters.GetCurrentStep]: (state: StepsState) => void;
  [StepsGetters.GetStepData]: (state: StepsState) => void;
  [StepsGetters.IsDataLoading]: (state: StepsState) => boolean;
  [StepsGetters.GetError]: (state: StepsState) => AppError;
  [StepsGetters.DisclaimerStatus]: (state: StepsState) => boolean;
  [StepsGetters.GetOnfidoToken]: (state: StepsState) => string;
}

export const getters: GetterTree<StepsState, State> & StepsGetterData = {
  [StepsGetters.GetCurrentStep](state) {
    return state.current;
  },

  [StepsGetters.GetStepData]: (state) => (stepName: string) => state.steps[stepName] ?? state.steps[stepName],
  [StepsGetters.IsDataLoading]: ({ isDataLoading }) => isDataLoading,
  [StepsGetters.GetError]: ({ error }) => error,
  [StepsGetters.DisclaimerStatus]: ({ steps }) => steps[STEPS_NAMES.selectDocuments].isDisclaimerChecked,
  [StepsGetters.GetOnfidoToken]: ({ steps }) => steps[STEPS_NAMES.validateDocuments].token,
} as const;
